import { useState } from 'react'
import {
  SETUP_ALL_MFA_ALREADY_REGISTERED_ERROR,
  SETUP_MFA_SELECTOR_FOOTNOTE,
  SETUP_MFA_SELECTOR_MESSAGE,
  SETUP_MFA_SELECTOR_TITLE,
} from '../../constants/ui.labels'
import { MFATypes } from '../../constants/mfa'
import ContentHeader from '../../components/ContentHeader'
import SetupMFACard from './SetupMFACard'
import PageFlow from '../../components/PageFlow'
import RecoveryOTPConfiguration from '../../components/RecoveryOTPConfiguration'
import Box from '@talkdesk/cobalt-react-box'
import Flex from '@talkdesk/cobalt-react-flex'
import IconWithProvider from '@talkdesk/cobalt-react-icon'
import Link from '@talkdesk/cobalt-react-link'
import { Heading, Text } from '@talkdesk/cobalt-react-typography'

const RECOVERY_CODES_STEP = 'RECOVERY_CODES_STEP'
const MFA_SELECTOR_STEP = 'MFA_SELECTOR_STEP'
const GO_BACK_ACTION = 'POP'

const SetupMFA = ({
  onSetupWebAuthn,
  onSetupTOTP,
  location,
  history,
  enabledMFAMechanisms,
  hasAllMFAEnabled,
  learnMoreAbout2FAUrl,
  recoveryFileTitle,
  recoveryFileName,
}) => {
  const [step, setStep] = useState(RECOVERY_CODES_STEP)

  const currentStep =
    history.action === GO_BACK_ACTION ? MFA_SELECTOR_STEP : step

  const hasMfaConfigured = (mfa) => enabledMFAMechanisms.includes(mfa)

  const recoveryCodeList =
    location && location.state && location.state.recoveryCodeList

  const renderEmptyMfaSelector = () => (
    <Box>
      <Flex
        direction='column'
        alignX='center'
        alignY='center'
        height='100%'
        padding='4'
      >
        <Box paddingBottom='4'>
          <IconWithProvider
            name='check_circle_outline'
            size='large'
            color='blue'
          />
        </Box>
        <Box paddingBottom='3'>
          <Heading level='2'>{SETUP_MFA_SELECTOR_TITLE}</Heading>
        </Box>
        <Text>{SETUP_ALL_MFA_ALREADY_REGISTERED_ERROR}</Text>
      </Flex>
    </Box>
  )

  const renderMfaSelector = () => (
    <Flex direction='column' gap='3' alignX='center' alignY='space-between'>
      <ContentHeader
        title={SETUP_MFA_SELECTOR_TITLE}
        message={SETUP_MFA_SELECTOR_MESSAGE}
      />
      {!hasMfaConfigured(MFATypes.WEB_AUTHN) && (
        <SetupMFACard mfaType={MFATypes.WEB_AUTHN} onClick={onSetupWebAuthn} />
      )}
      {!hasMfaConfigured(MFATypes.TOTP) && (
        <SetupMFACard mfaType={MFATypes.TOTP} onClick={onSetupTOTP} />
      )}
      <Flex paddingY='5' alignX='center'>
        <Link target='_blank' href={learnMoreAbout2FAUrl}>
          {SETUP_MFA_SELECTOR_FOOTNOTE}
        </Link>
      </Flex>
    </Flex>
  )

  return (
    <PageFlow currentStep={currentStep}>
      <PageFlow.Step name={RECOVERY_CODES_STEP}>
        <RecoveryOTPConfiguration
          otpList={recoveryCodeList}
          onConfirm={() => setStep(MFA_SELECTOR_STEP)}
          fileTitle={recoveryFileTitle}
          fileName={recoveryFileName}
        />
      </PageFlow.Step>
      <PageFlow.Step name={MFA_SELECTOR_STEP}>
        {hasAllMFAEnabled ? renderEmptyMfaSelector() : renderMfaSelector()}
      </PageFlow.Step>
    </PageFlow>
  )
}

export default SetupMFA
